const t={defaultProps:{variantMapping:{title:"h1"}}};export{t as default};
